import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { makeClassName } from '../../../utils';

import './style.scss';

class Form extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(event) {
    event.preventDefault();

    const inputs = Array.from(event.target.elements);
    const data = inputs.reduce((values, input) => {
      if (input.name) {
        if (input.attributes.type && input.attributes.type.value === 'checkbox' ) {
          if (input.checked) {
            values[input.name] = (Array.isArray(values[input.name]) && values[input.name].length) ?
              [...values[input.name], input.value] : [input.value];
          } else if (input.checked === false) {
            if (!Array.isArray(values[input.name])){
              values[input.name] = [];
            }
          }
        }
        else {
          values[input.name] = input.value;
        }
      }
      return values;
    }, {});

    if (this.props.onSubmit) {
      this.props.onSubmit(data);
    }
  }

  render() {
    const {children, id, className } = this.props;
    return (
      <form
        data-testid={id}
        id={id}
        className={makeClassName("ucop-form", className)}
        onSubmit={this.onSubmit}
      >
        {children}
      </form>
    );
  }
}

Form.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  onSubmit: PropTypes.func
};

export default Form;
